import { LOGO_ICON } from "@/lib/brand";

// My Clean Connect wordmark: "My" green, "Clean" blue, "Connect" green (matches logo)
export default function Wordmark({ light = false, iconClass = "h-9 w-auto", textClass = "text-xl" }) {
  return (
    <span className="flex items-center gap-2">
      <img src={LOGO_ICON} alt="My Clean Connect" className={`${iconClass} object-contain`} />
      <span className={`font-display font-bold tracking-tight ${textClass} ${light ? "text-white" : ""}`}>
        {light ? (
          <>My Clean Connect<sup className="text-[0.5em] top-[-0.8em]">™</sup></>
        ) : (
          <>
            <span className="text-[#4C9E22]">My </span>
            <span className="text-[#0086C0]">Clean </span>
            <span className="text-[#4C9E22]">Connect</span>
            <sup className="text-[0.5em] top-[-0.8em] text-[#4C9E22]">™</sup>
          </>
        )}
      </span>
    </span>
  );
}
